import { Observable, of } from "rxjs";

import { LogEntry } from "@core/classes";
import { LogPublisher } from "@shared/models/log.interface";

export class ConsoleLog implements LogPublisher {
  location: string = '';

  constructor() {}

  log (entry: LogEntry): Observable<boolean> {
    console.log(entry.buildLogString());
    return of(true);
  }

  clear(): Observable<boolean> {
    console.clear();
    return of(true);
  }
}
